const openCookiePreferences = () => {
    if (typeof window.openAxeptioCookies === 'function') {
        window.openAxeptioCookies();

        return true;
    }

    window._axcb = window._axcb || [];
    window._axcb.push(() => {
        if (typeof window.openAxeptioCookies === 'function') {
            window.openAxeptioCookies();
        }
    });

    return false;
};

document.addEventListener('click', (event) => {
    const link = event.target.closest('[data-corim-cookie-preferences]');

    if (!link) {
        return;
    }

    if (openCookiePreferences()) {
        event.preventDefault();
    }
});
